import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Modal } from "ui";

import { useCreateVideo, useUpdateVideo } from "../../../apis";
import {
  convertVideoFormDataToUpdateBody,
  getInitialVideoFormValues
} from "../../../helpers";
import { VideoForm, VideoFormValues } from "../../forms";
import { VideoModalProps } from "../components.types";

const VIDEO_FORM_ID = "video-form-id";

const VideoModal = ({
  isOpen,
  onClose,
  editableVideo,
  refetchVideos
}: VideoModalProps) => {
  const { t } = useTranslation();
  const { mutate: mutateCreateVideo, isLoading: isCreateVideoLoading } =
    useCreateVideo({
      onSuccess: () => {
        toast.success(t("Video created successfully"));
        onClose();
        refetchVideos();
      }
    });

  const { mutate: mutateUpdateVideo } = useUpdateVideo({
    onSuccess: () => {
      toast.success(t("Video updated successfully"));
      onClose();
      refetchVideos();
    }
  });

  const handleFormSubmit = (formData: VideoFormValues) => {
    if (formData.id) {
      const body = convertVideoFormDataToUpdateBody(formData);
      mutateUpdateVideo(body);
    } else {
      const body = {
        title: formData.title,
        description: formData.description,
        targetResellerLevel: formData.targetResellerLevel,
        isOrderTutorial: formData.isOrderTutorial,
        isWebviewTutorial: formData.isWebviewTutorial,
        videoMediaId: formData.video?.id,
        thumbnailId: formData.thumbnail?.id
      };

      mutateCreateVideo(body);
    }
  };

  return (
    <Modal
      formId={VIDEO_FORM_ID}
      isOpen={isOpen}
      title={`${editableVideo ? "Edit" : "Add"} Video`}
      isLoading={isCreateVideoLoading}
      okText={editableVideo ? "Save" : "Submit"}
      onClose={onClose}
    >
      <VideoForm
        formId={VIDEO_FORM_ID}
        onSubmit={handleFormSubmit}
        defaultValues={getInitialVideoFormValues(editableVideo)}
      />
    </Modal>
  );
};

export default VideoModal;
